module.exports = __webpack_public_path__ + "img/profile-navbar-icon.a823911d.svg";